/* eslint-disable */
import { useState } from "react";
import { C } from "../shared/globals.js";

function AllocationBar({ assetData, totalValue, COLORS }) {
  const [hovered, setHovered] = useState(null);

  const sorted = [...assetData].sort((a, b) => b.currentValue - a.currentValue);
  const segments = sorted.map((a, i) => ({
    ticker: a.ticker,
    pct: totalValue > 0 ? a.currentValue / totalValue : 0,
    color: COLORS[i % COLORS.length],
  }));

  return (
    <div>
      {/* Bar */}
      <div style={{ display:"flex", height:32, borderRadius:8, overflow:"hidden", gap:1 }}>
        {segments.map(s => {
          const isHov = hovered === s.ticker;
          const dimmed = hovered && !isHov;
          return (
            <div key={s.ticker}
              style={{
                width: `${s.pct * 100}%`,
                background: dimmed ? "#2a2a2a" : s.color,
                display:"flex", alignItems:"center", justifyContent:"center",
                minWidth: s.pct > 0.05 ? "auto" : 0,
                overflow:"hidden", flexShrink:0,
                transition:"background 0.2s",
                cursor:"default",
              }}
              onMouseEnter={() => setHovered(s.ticker)}
              onMouseLeave={() => setHovered(null)}
            >
              {s.pct > 0.07 && (
                <span style={{
                  fontFamily:"Montserrat,sans-serif", fontSize:9, fontWeight:800,
                  color: dimmed ? "#555" : "#000",
                  letterSpacing:"0.05em", whiteSpace:"nowrap",
                  transition:"color 0.2s",
                }}>
                  {s.ticker}
                </span>
              )}
            </div>
          );
        })}
      </div>

      {/* Labels */}
      <div style={{ display:"flex", flexWrap:"wrap", gap:"10px 20px", marginTop:12, justifyContent:"center" }}>
        {segments.map(s => {
          const isHov = hovered === s.ticker;
          const dimmed = hovered && !isHov;
          return (
            <div key={s.ticker}
              style={{
                display:"flex", alignItems:"center", gap:6, cursor:"default",
                opacity: dimmed ? 0.25 : 1,
                transition:"opacity 0.2s",
              }}
              onMouseEnter={() => setHovered(s.ticker)}
              onMouseLeave={() => setHovered(null)}
            >
              <div style={{
                width: isHov ? 10 : 8,
                height: isHov ? 10 : 8,
                borderRadius:"50%",
                background: s.color,
                flexShrink:0,
                transition:"width 0.15s, height 0.15s",
              }}/>
              <span style={{
                fontFamily:"Montserrat,sans-serif", fontSize:11, fontWeight:700,
                color: isHov ? "var(--text)" : "var(--text3)",
                transition:"color 0.15s",
              }}>
                {s.ticker}
              </span>
              <span style={{
                fontFamily:"Montserrat,sans-serif", fontSize:11, fontWeight:400,
                color: isHov ? "var(--text3)" : "var(--text4)",
                transition:"color 0.15s",
              }}>
                {(s.pct * 100).toFixed(1)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AllocationBar;
